import styled, { createGlobalStyle } from 'styled-components'

const EstiloGlobal = createGlobalStyle`
  dl, ol, ul{
    margin-top: 0;
    margin-bottom: 1em;
  }

  * {
    margin: 0;
    padding: 0;
    text-decoration: none;
    outline: none;
    list-style: none;
    border: none;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    font-size: 16px;
    font-family: 'Inter';
  }

  button {
    background-color: transparent;
    cursor: pointer;
  }

  img {
    display: block;
  }

  input {
    appearance: none;
  }

  .medium-zoom-image--opened{
    margin-top: 8em;
    transform: scale(1.1) translate3d(221.721px, -210px, 0px);
  }

  .container {
    max-width: 1310px;
    width: 100%;
    padding: 0px 15px;
    margin-left: auto;
    margin-right: auto;
  }

  select {
    width: 100%;
    height: 40px;
    appearance: none;
    border: 1px solid #DCDDE3;
    border-radius: 6px;
    padding: 0px 18px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #A0A4B3;
    background: url("/images/svg/arrow-select.svg") no-repeat right 20px center;
  }
`

export const StyleInput = styled.div`
  margin-bottom: 24px;
  position: relative;
  .topInput {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    span {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 17px;
      text-align: center;
      letter-spacing: -0.1px;
      color: #8a8a8a;
    }
  }
  label {
    font: normal 500 14px/17px 'Inter';
    color: #363843;
    display: block;
    margin-bottom: 11px;
    clear: left;
  }
  div {
    position: relative;
  }
  input {
    width: 100%;
    height: 54px;
    border: 1px solid;
    border: 1px solid #dcdde3;
    border-radius: 6px;
    padding: 0px 18px;
    font-size: 14px;
    color: #646981;
    &::placeholder {
      color: #a0a4b3;
    }
  }
  img {
    position: absolute;
    top: 19px;
    right: 32px;
    cursor: pointer;
  }
  select {
    width: 109px;
    height: 54px;
    &:disabled {
      background-color: #e0e0e0;
    }
  }
  .select-100 {
    width: 100%;
  }
  input.has-error {
    border-color: #bc3838;
  }
  select.has-error {
    border-color: #bc3838;
  }
  .error {
    font: normal 500 12px 'Inter';
    color: #bc3838;
  }
  @media (max-width: 1200px) {
    &:last-child {
      margin-bottom: 0px;
    }
    select {
      width: 100%;
    }
  }
  @media (max-width: 480px) {
    margin-bottom: 15px;
  }
`

export const InputHidden = styled.input`
  display: none;
`

export default EstiloGlobal
